import { createSlice, createAction, PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { mfaFlow } from "utils/enum";
import { createActionDispatchers } from "utils/reduxHelpers";

export type State = {
  emailOtpLoading: boolean;
  emailOtpError: string | null;
  emailOtpVerifyDone: boolean;
  emailOtpRemoveDone: boolean;
  currentFlow: mfaFlow | null;
};

export const initialState: State = {
  emailOtpLoading: false,
  emailOtpError: null,
  emailOtpVerifyDone: false,
  emailOtpRemoveDone: false,
  currentFlow: null,
};

const slice = createSlice({
  name: "emailAuthenticator",
  initialState,
  // create actions with reducer (slice action) here
  reducers: {
    emailOtpSendStart(state: State) {
      state.emailOtpLoading = true;
      state.emailOtpError = null;
    },
    emailOtpSendDone(state: State) {
      state.emailOtpLoading = false;
    },
    emailOtpSendError(state: State, action: PayloadAction<string>) {
      state.emailOtpLoading = false;
      state.emailOtpError = action.payload;
    },
    emailOtpVerifyStart(state: State) {
      state.emailOtpLoading = true;
      state.emailOtpError = null;
    },
    emailOtpVerifyError(state: State, action: PayloadAction<string>) {
      state.emailOtpLoading = false;
      state.emailOtpError = action.payload;
    },
    emailOtpVerifyDone(state: State) {
      state.emailOtpLoading = false;
      state.emailOtpError = null;
      state.emailOtpVerifyDone = true;
    },
    emailOtpRemoveStart(state: State) {
      state.emailOtpLoading = true;
      state.emailOtpError = null;
    },
    emailOtpRemoveError(state: State, action: PayloadAction<string>) {
      state.emailOtpLoading = false;
      state.emailOtpError = action.payload;
    },
    emailOtpRemoveDone(state: State) {
      state.emailOtpLoading = false;
      state.emailOtpError = null;
      state.emailOtpRemoveDone = true;
    },
    emailOtpReset(state: State) {
      state.emailOtpLoading = false;
      state.emailOtpError = null;
      state.emailOtpVerifyDone = false;
      state.emailOtpRemoveDone = false;
    },
  },
  // reducer for external action
  // extraReducers: (builder) => {
  //   builder.addCase(externalAction, (state) => {
  //   });
  // },
});

export const onEmailOtpSend = createAction<mfaFlow>(
  "emailAuthenticator/onEmailOtpSend"
);
export const onEmailOtpVerify = createAction<{ code: string; flow: mfaFlow }>(
  "emailAuthenticator/onEmailOtpVerify"
);
export const onEmailOtpRemove = createAction(
  "emailAuthenticator/onEmailOtpRemove"
);
export const setCurrentFlow = createAction<mfaFlow>(
  "emailAuthenticator/setCurrentFlow"
);

/**
 * actions from slice to be exported for saga
 */
export const {
  emailOtpSendStart,
  emailOtpSendDone,
  emailOtpSendError,
  emailOtpVerifyStart,
  emailOtpVerifyError,
  emailOtpVerifyDone,
  emailOtpRemoveStart,
  emailOtpRemoveError,
  emailOtpRemoveDone,
  emailOtpReset,
} = slice.actions;

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  // slice actions
  [],
  // pure actions
  {
    onEmailOtpSend,
    onEmailOtpVerify,
    onEmailOtpRemove,
    onEmailOtpReset: () => slice.actions.emailOtpReset(),
    goToMfaScreen: (redirect) => push(redirect),
    setCurrentFlow,
  }
);

export default slice.reducer;
